const defaultMeta = {
  title: '智面玄赏 - 悬赏招聘 | AI面试平台 | AI分润式招聘平台',
  keywords: '智面玄赏, AI面试平台, AI招聘平台, AI简历优化, AI模拟面试, AI简历筛选、悬赏招聘, 悬赏求职, 招聘降本增效, AI分润式招聘平台',
  description: '智面玄赏是一家基于AI的分润式招聘平台，首创分润式招聘模式，通过AI简历筛选+AI面试系统帮助企业提高招聘效率，实现降本增效；同时为求职者提供AI简历优化与模拟面试服务，提升入职成功率。创新“悬赏招聘”机制，实现招聘按结果付费、零风险高效招人。'
}

const staticRoutes = [
  { name: 'newIndex', path: '/', output: '/index.html', meta: defaultMeta },
  { name: 'bountyRecruitment', path: '/bountyRecruitment', output: '/bountyRecruitment/index.html', meta: defaultMeta },
  { name: 'cooperation', path: '/cooperation', output: '/cooperation/index.html', meta: defaultMeta },
  { name: 'talent', path: '/talent-management', output: '/talent-management/index.html', meta: defaultMeta },
  { name: 'interview', path: '/interview', output: '/interview/index.html', meta: defaultMeta },
  { name: 'offerBot', path: '/offerBot', output: '/offerBot/index.html', meta: defaultMeta },
  { name: 'employment', path: '/employment', output: '/employment/index.html', meta: defaultMeta },
  { name: 'example', path: '/example', output: '/example/index.html', meta: defaultMeta },
  { name: 'news', path: '/news', output: '/news/index.html', meta: defaultMeta },
  { name: 'about-us', path: '/about-us', output: '/about-us/index.html', meta: defaultMeta }
]

const spaRoutes = [
  { name: 'Login', path: '/login' },
  { name: 'Login_wx', path: '/login_wx' },
  { name: 'Login_phone', path: '/login_phone' },
  { name: 'Template', path: '/template' },
  { name: 'Tempdeil', path: '/template/:id' },
  { name: 'Diag', path: '/diag' },
  { name: 'Personal', path: '/personal' },
  { name: 'Headimg', path: '/headimg' },
  { name: 'Phone', path: '/phone' },
  { name: 'Pwd', path: '/pwd' },
  { name: 'Order', path: '/order' },
  { name: 'Orderdeil', path: '/orderdeil/:id' },
  { name: 'Resume', path: '/resume' },
  { name: 'Myresume', path: '/myresume' },
  { name: 'register', path: '/register' },
  { name: 'forget', path: '/forget' },
  { name: 'eventregistration', path: '/eventregistration/:sourceId' },
  { name: 'success', path: '/eventregistrationSuccess' },
  { name: 'questionnaireSurvey', path: '/questionnaireSurvey' },
  { name: 'questionnaireSurveySuccess', path: '/questionnaireSurveySuccess' },
  { name: 'lot', path: '/lot' },
  { name: 'post', path: '/post' },
  { name: 'new', path: '/new' },
  { name: 'newsdeil', path: '/news/:id.html' },
  { name: 'list2', path: '/list2.html' },
  { name: 'list3', path: '/list3.html' },
  { name: 'list4', path: '/list4.html' },
  { name: 'newsdetails', path: '/newsdetails/:id' }
].map(route => ({
  ...route,
  output: '/spa/index.html',
  meta: defaultMeta,
  spa: true
}))

const allRoutes = [...staticRoutes, ...spaRoutes]
const extraPageOutputs = {
  spa: '/spa/index.html'
}

const routeByName = allRoutes.reduce((acc, route) => {
  acc[route.name] = route
  return acc
}, {})

const pathMetaList = allRoutes.map(route => ({
  ...route,
  regex: createPathRegex(route.path),
  paramNames: extractParamNames(route.path)
}))

function extractParamNames(path) {
  return (path.match(/:([A-Za-z0-9_]+)/g) || []).map(key => key.slice(1))
}

function createPathRegex(path) {
  const pattern = path
    .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    .replace(/:([A-Za-z0-9_]+)/g, '([^/]+)')
  return new RegExp(`^${pattern}$`)
}

function fillParams(path, params = {}) {
  return path.replace(/:([A-Za-z0-9_]+)/g, (_, key) => encodeURIComponent(params[key] || ''))
}

function normalizeQuery(query = {}) {
  const searchParams = new URLSearchParams()
  Object.keys(query).forEach(key => {
    const value = query[key]
    if (value !== undefined && value !== null && value !== '') {
      searchParams.append(key, value)
    }
  })
  const queryString = searchParams.toString()
  return queryString ? `?${queryString}` : ''
}

function normalizeHash(hash = '') {
  if (!hash) {
    return ''
  }

  return hash.startsWith('#') ? hash : `#${hash}`
}

function createHref(route, params = {}, query = {}, hash = '') {
  const queryString = normalizeQuery(query)
  const hashString = normalizeHash(hash)
  const currentOutput = getCurrentOutput()
  const targetOutput = route.output || '/index.html'
  const baseHref = getRelativePath(currentOutput, targetOutput)

  if (route.spa) {
    const resolvedPath = fillParams(route.path, params)
    return `${baseHref}#${resolvedPath}${queryString}${hashString}`
  }

  return `${baseHref}${queryString}${hashString}`
}

function getCurrentOutput() {
  if (typeof window === 'undefined' || !window.location) {
    return getOutputByPageName('newIndex')
  }

  if (window.__MULTI_PAGE_ROUTE__ && window.__MULTI_PAGE_ROUTE__.name) {
    return getOutputByPageName(window.__MULTI_PAGE_ROUTE__.name)
  }

  const pathname = window.location.pathname || ''
  if (/\/spa\/index\.html$/i.test(pathname)) {
    return getOutputByPageName('spa')
  }

  return getOutputByPageName('newIndex')
}

function findRouteByPath(path) {
  const purePath = path.split('?')[0]
  for (const route of pathMetaList) {
    const match = purePath.match(route.regex)
    if (!match) {
      continue
    }

    const params = route.paramNames.reduce((acc, key, index) => {
      acc[key] = decodeURIComponent(match[index + 1] || '')
      return acc
    }, {})

    return { route, params }
  }

  return null
}

export function resolveHref(location) {
  if (typeof location === 'string') {
    if (/^(https?:)?\/\//.test(location)) {
      return location
    }
    const matched = findRouteByPath(location)
    if (matched) {
      return createHref(matched.route, matched.params)
    }
    return location
  }

  if (location && typeof location === 'object') {
    if (location.name && routeByName[location.name]) {
      return createHref(routeByName[location.name], location.params, location.query, location.hash)
    }
    if (location.path) {
      const matched = findRouteByPath(fillParams(location.path, location.params))
      if (matched) {
        return createHref(matched.route, matched.params, location.query, location.hash)
      }
      return `${location.path}${normalizeQuery(location.query)}${normalizeHash(location.hash)}`
    }
  }

  return '/'
}

export function getCurrentRoute(pageName) {
  const route = routeByName[pageName] || routeByName.newIndex

  return {
    name: route.name,
    path: route.path,
    fullPath: route.path,
    output: route.output,
    params: {},
    query: {},
    meta: route.meta || {}
  }
}

export function getOutputByPageName(pageName) {
  if (pageName && extraPageOutputs[pageName]) {
    return extraPageOutputs[pageName]
  }
  const route = routeByName[pageName] || routeByName.newIndex
  return route.output || '/index.html'
}

export function getAssetBaseByPageName(pageName) {
  return getAssetBase(getOutputByPageName(pageName))
}

function getAssetBase(output) {
  const segments = splitPath(output)
  const depth = Math.max(segments.length - 1, 0)
  return depth ? '../'.repeat(depth) : ''
}

function getRelativePath(fromOutput, toOutput) {
  const fromSegments = splitPath(fromOutput)
  const toSegments = splitPath(toOutput)
  const fromDirSegments = fromSegments.slice(0, -1)

  let commonIndex = 0
  while (
    commonIndex < fromDirSegments.length &&
    commonIndex < toSegments.length &&
    fromDirSegments[commonIndex] === toSegments[commonIndex]
  ) {
    commonIndex += 1
  }

  const upSegments = new Array(fromDirSegments.length - commonIndex).fill('..')
  const downSegments = toSegments.slice(commonIndex)
  const relativePath = [...upSegments, ...downSegments].join('/')

  return relativePath || 'index.html'
}

function splitPath(path) {
  return path.replace(/^\//, '').split('/').filter(Boolean)
}

export function getRouterOptionsRoutes() {
  return allRoutes.map(route => ({
    name: route.name,
    path: route.path,
    meta: route.meta || {}
  }))
}

export function applyRouteMeta(route) {
  const meta = route.meta || {}

  if (meta.title) {
    document.title = meta.title
  }

  setMetaContent('keywords', meta.keywords || '')
  setMetaContent('description', meta.description || '')
}

function setMetaContent(name, content) {
  let meta = document.querySelector(`meta[name="${name}"]`)
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute('name', name)
    document.head.appendChild(meta)
  }
  meta.setAttribute('content', content)
}
